/*
  2026-10-02, home rail pickers and sort (sections/featured-collection, settings
  ss_picker = marcas | categorias and ss_sort). Each rail root carries
  [data-ss-rail]:
  - A click on a pick in [data-ss-pick] fetches that collection's cards and
    swaps them into the rail, then updates the chip, "ver todo +" and the
    microcopy. Logged out, the last pick is remembered per browser
    (localStorage key in data-remember, one per picker).
  - [data-ss-sort] orders the rail: recent / low / high go to Shopify as
    ?sort_by= on sections/ss-brand-rail-cards; off (biggest discount) uses
    sections/ss-rail-cards-off. With data-mode="client" (Para ti, a fixed list)
    the cards are reordered in place from their data-price / data-off / data-t.
  Without JS the links open the collection and the sort does nothing.
  2026-10-08: the Todo / Hombre / Mujer switch (window.ssGenero, assets/
  ss-genero.js). A rail showing New In, Ropa, Zapatos or Accesorios fetches its
  cards with the gender filter, and refetches on 'ss:genero'. New In carries
  the switch itself ([data-ss-gen-rail]); it is hidden while the first
  filtered cards load (html.ss-gen-pending, set in layout/theme.liquid).
*/
(function () {
  var SORT_BY = { recent: 'created-descending', low: 'price-ascending', high: 'price-descending' };
  var cache = {};

  function read(key) {
    try { return localStorage.getItem(key); } catch (e) { return null; }
  }
  function write(key, v) {
    try { localStorage.setItem(key, v); } catch (e) {}
  }

  // Bags and jewelry show everything, whatever the switch says.
  var GEN_EXEMPT = ['bolsas', 'joyeria'];

  function handleOf(href) {
    var m = new URL(href, location.origin).pathname.match(/\/collections\/([^\/?#]+)\/?$/);
    return m ? m[1].toLowerCase() : null;
  }

  function genExempt(href) {
    return GEN_EXEMPT.indexOf(handleOf(href)) >= 0;
  }

  // Gender filter for a rail's collection: rails with the switch filter any
  // collection but bags and jewelry; the others only the covered ones.
  function genParams(href, root) {
    var G = window.ssGenero;
    if (!G || !href) return [];
    var v = G.get();
    if (v === 'todo') return [];
    if (root && root.hasAttribute('data-ss-gen-rail')) return genExempt(href) ? [] : G.params(v);
    return G.handle(href) ? G.params(v) : [];
  }

  function addGen(u, href, root) {
    genParams(href, root).forEach(function (p) { u.searchParams.append(p[0], p[1]); });
    return u;
  }

  function cardsUrl(href, sort, root) {
    var u = new URL(href, location.origin);
    u.search = '';
    if (sort === 'off') {
      u.searchParams.set('section_id', 'ss-rail-cards-off');
    } else {
      u.searchParams.set('section_id', 'ss-brand-rail-cards');
      u.searchParams.set('sort_by', SORT_BY[sort] || SORT_BY.recent);
    }
    return addGen(u, href, root).toString();
  }

  function viewAllUrl(href, sort, root) {
    var u = new URL(href, location.origin);
    u.search = '';
    if (sort === 'low' || sort === 'high') u.searchParams.set('sort_by', SORT_BY[sort]);
    addGen(u, href, root);
    return u.pathname + u.search;
  }

  function fetchCards(url) {
    if (!cache[url]) {
      cache[url] = fetch(url, { credentials: 'same-origin' })
        .then(function (r) {
          if (!r.ok) throw new Error(r.status);
          return r.text();
        })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          return Array.prototype.slice.call(doc.querySelectorAll('[data-ss-pick-cards] > li'));
        })
        .catch(function (err) {
          delete cache[url];
          throw err;
        });
    }
    return cache[url];
  }

  function num(li, key) {
    return Number(li.getAttribute('data-' + key)) || 0;
  }

  function initRail(root) {
    var sectionId = root.getAttribute('data-id');
    var list = root.querySelector('#Slider-' + sectionId);
    if (!list) return;
    var slider = root.querySelector('slider-component');
    var label = root.querySelector('[data-ss-pick-label]');
    var badge = root.querySelector('[data-ss-pick-badge]');
    var all = root.querySelector('[data-ss-pick-all]');
    var copy = root.querySelector('[data-ss-pick-copy]');
    var nav = root.querySelector('[data-ss-pick]');
    var sortSel = root.querySelector('[data-ss-sort]');
    var client = sortSel && sortSel.getAttribute('data-mode') === 'client';
    var remember = nav && nav.getAttribute('data-remember');
    var items = nav ? Array.prototype.slice.call(nav.querySelectorAll('.ss-pick__item')) : [];
    var current = items.filter(function (el) { return el.getAttribute('aria-current') === 'true'; })[0];

    var first = list.querySelector('li');
    var liClass = first ? first.className.replace(/\bscroll-trigger\b|\banimate--slide-in\b/g, '').trim() : 'grid__item';
    var original = Array.prototype.slice.call(list.children);
    var state = {
      href: current ? current.getAttribute('href') : all ? (all.getAttribute('data-ss-gen-href') || all.getAttribute('href')) : null,
      sort: sortSel ? sortSel.value : 'recent',
      gen: '[]'
    };
    var seq = 0;

    function resetSlider() {
      list.scrollLeft = 0;
      if (slider && typeof slider.resetPages === 'function') slider.resetPages();
    }

    function place(cards) {
      list.innerHTML = '';
      cards.forEach(function (card, i) {
        var li = document.createElement('li');
        li.className = liClass;
        li.id = 'Slide-' + sectionId + '-' + (i + 1);
        ['price', 'off', 't'].forEach(function (k) {
          if (card.hasAttribute('data-' + k)) li.setAttribute('data-' + k, card.getAttribute('data-' + k));
        });
        li.innerHTML = card.innerHTML;
        list.appendChild(li);
      });
      resetSlider();
    }

    function load(href, sort, item, save) {
      var mine = ++seq;
      root.setAttribute('data-ss-pick-busy', '');
      var gen = JSON.stringify(genParams(href, root));
      return fetchCards(cardsUrl(href, sort, root))
        .then(function (cards) {
          if (mine !== seq || !cards.length) return;
          place(cards);
          state.href = href;
          state.sort = sort;
          state.gen = gen;
          if (root.hasAttribute('data-ss-gen-rail')) root.toggleAttribute('data-ss-gen-off', genExempt(href));
          if (item) {
            items.forEach(function (el) {
              if (el === item) el.setAttribute('aria-current', 'true');
              else el.removeAttribute('aria-current');
            });
            if (label) label.textContent = item.textContent.trim().toLowerCase();
            if (copy) copy.textContent = item.getAttribute('data-copy') || '';
            if (save && remember) write(remember, item.getAttribute('data-key'));
          }
          if (badge) badge.setAttribute('href', href);
          if (all) all.setAttribute('href', viewAllUrl(href, sort, root));
        })
        .catch(function () {
          if (item) location.href = href;
        })
        .then(function () {
          if (mine === seq) root.removeAttribute('data-ss-pick-busy');
        });
    }

    function sortInPlace(sort) {
      var cards = original.slice();
      if (sort === 'recent') cards.sort(function (a, b) { return num(b, 't') - num(a, 't'); });
      else if (sort === 'low') cards.sort(function (a, b) { return num(a, 'price') - num(b, 'price'); });
      else if (sort === 'high') cards.sort(function (a, b) { return num(b, 'price') - num(a, 'price'); });
      else if (sort === 'off') cards.sort(function (a, b) { return num(b, 'off') - num(a, 'off'); });
      list.innerHTML = '';
      cards.forEach(function (li, i) {
        li.id = 'Slide-' + sectionId + '-' + (i + 1);
        list.appendChild(li);
      });
      resetSlider();
      state.sort = sort;
    }

    items.forEach(function (item) {
      item.addEventListener('click', function (e) {
        if (e.metaKey || e.ctrlKey || e.shiftKey || e.button === 1) return;
        e.preventDefault();
        if (item.getAttribute('aria-current') === 'true') return;
        item.scrollIntoView({ block: 'nearest', inline: 'center', behavior: 'smooth' });
        load(item.getAttribute('href'), state.sort, item, true);
      });
    });

    if (sortSel) {
      sortSel.addEventListener('change', function () {
        if (client) sortInPlace(sortSel.value);
        else if (state.href) load(state.href, sortSel.value, null, false);
      });
    }

    var initial = null;
    if (remember) {
      var saved = read(remember);
      var match = saved && items.filter(function (el) { return el.getAttribute('data-key') === saved; })[0];
      if (match && match !== current) {
        nav.scrollLeft += match.getBoundingClientRect().left - nav.getBoundingClientRect().left - 16;
        initial = load(match.getAttribute('href'), state.sort, match, false);
      }
    }

    // The server rendered every gender: refetch now if the switch says otherwise,
    // and whenever it changes.
    if (!initial && !client && genParams(state.href, root).length) initial = load(state.href, state.sort, null, false);
    if (root.hasAttribute('data-ss-gen-rail')) {
      Promise.resolve(initial).then(function () {
        document.documentElement.classList.remove('ss-gen-pending');
      });
    }
    document.addEventListener('ss:genero', function () {
      if (client || !state.href) return;
      if (JSON.stringify(genParams(state.href, root)) !== state.gen) load(state.href, state.sort, null, false);
    });
  }

  function boot() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-ss-rail]'), function (root) {
      if (root.__ssRail) return;
      root.__ssRail = true;
      initRail(root);
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
